import React from 'react';
import { map } from "lodash";
import renderRawHtml from '../../../common/render_raw_html';
import thumb from '../../../../../images/verizon/email_app/thumb.png';
import wallet from '../../../../../images/verizon/email_app/wallet.png';
import connector from '../../../../../images/verizon/email_app/connector.png';
import FooterSocialMenu from './components/footerSocialMenu';

const WifiBackup = ({ emailData }) => {
  const introTextCustomer = [
    "Life doesn't hit pause when your internet does. As a valued mobile customer, you know the power of our award-winning wireless network. Now, you can use that power with Verizon Wi-Fi Backup.",
    "Stay connected when your primary internet connection goes down with unlimited back-up data for up to 7 days a month as needed. Stay connected at &lt;Street Address&gt; and don't let service outages derail your workday or interrupt your gaming, streaming and learning."
  ];

  const introTextProspect = [
    "Life doesn't hit pause when your internet does. Wi-Fi Backup from Verizon keeps you connected when your primary internet connection goes down with unlimited back-up data for up to 7 days a month as needed. Stay connected at &lt;Address&gt; and don't let service outages derail your workday or interrupt your gaming, streaming and learning."
  ];

  const colsListCustomer = [
    {
      title: "Affordable",
      icon: wallet,
      text: [
        "Get connected for $20/mo with Auto Pay and any Verizon mobile phone plan.* Price includes Mobile + Home Discount. Unlock seven 24-hour backup sessions with unlimited data."
      ]
    },
    {
      title: "Reliable",
      icon: thumb,
      text: [
        "Verizon’s award-winning wireless network provides a backup connection you can count on."
      ]
    },
    {
      title: "Simple",
      icon: connector,
      text: [
        "Verizon Wi-Fi Backup is easy to set up, so you can experience peace of mind right away."
      ]
    }
  ];

  const colsListProspect = [
    {
      title: "Reliable",
      icon: thumb,
      text: [
        "Verizon’s award-winning wireless network provides a backup connection you can count on."
      ]
    },
    {
      title: "Affordable",
      icon: wallet,
      text: [
        "Get connected for $20/mo with Auto Pay and any Verizon mobile phone plan.* Unlock seven 24-hour sessions with unlimited data. Router included at no extra cost."
      ]
    },

    {
      title: "Simple",
      icon: connector,
      text: [
        "Verizon Wi-Fi Backup is easy to set up, so you can experience peace of mind right away."
      ]
    }
  ];

  const telNumbers = [ '888.529.1087', '800.722.2632' ];

  const { type } = emailData;
  const colsList = type === "customer" ? colsListCustomer : colsListProspect;
  const introText = type === "customer" ? introTextCustomer : introTextProspect;
  const telNumber = type === "customer" ? telNumbers[0] : telNumbers[1];

  return (
    <div className="email">
      <div className="email_header">
        <div className="email_header-logo">
          <svg className="email_header-logo-img">
            <use xlinkHref={ `#svg_verizon-long-branded` } />
          </svg>
        </div>
        <ul className="email_header-menu">
          <li>Devices</li>
          <li>Plans</li>
          <li className="hide-in-mobile">Why Verizon</li>
        </ul>
      </div>
      <div className="email_hero -red -big-padding">
        <div className="email_hero-content -center -short">
          <h1 className="email_hero-title">
            <span className="email_text -color-yellow block-in-mobile">Stay connected</span> with
            { ' ' }
            Verizon Wi-Fi Backup
          </h1>
          <div className="email_hero-text -bold -small">
            Meet your new home internet hero. Now you’ll be covered when your primary connection goes down.
          </div>
          <div className="email_hero-button">
            <div className="email_button -bordered -inherit">Check it out</div>
          </div>
        </div>
      </div>

      <div className="email_content">

        <div className="email_content-section">
          <div className="email_content-intro">
            <h2 className="email_content-intro-title">
              Wi-Fi that has
              <br />
              <span className="email_text -color-red">your back</span>
            </h2>
            <div className="email_content-intro-text">
              {
                map(introText, (itemText, index) => (
                  <p key={ index } { ...renderRawHtml(itemText) } />
                ))
              }
            </div>
          </div>
        </div>

        <div className="email_content-section">
          <div className="email_content-cols">
            {
              map(colsList, (item, index) => (
                <div
                  key={ index }
                  className="email_content-col"
                >
                  <div className="email_content-plate -stone">
                    <div className="email_content-plate-icon">
                      <img src={ item.icon } alt="" />
                    </div>
                    <h4 className="email_content-plate-title">
                      {item.title}
                    </h4>
                    {
                      map(item.text, (itemText, index) => (
                        <p
                          key={ index }
                          className="email_content-plate-p"
                          { ...renderRawHtml(itemText) }
                        />
                      ))
                    }
                  </div>
                </div>
              ))
            }
          </div>
          <div className="email_content-more-link">
            Get started
            <span className="email_icon-more" />
          </div>
        </div>

        <div className="email_content-section">
          <div className="email_banner -grid">
            <div className="email_banner-image -in-grid">
              <svg className="email_banner-image-img">
                <use xlinkHref={ `#svg_verizon-short-branded` } />
              </svg>
            </div>
            <div className="email_banner-content -in-grid">
              Powering how you live, work and play
            </div>
          </div>
        </div>

        <div className="email_content-section footer-buttons">
          <div className="email_content-cols">
            <div className="email_content-col">
              <div className="email_content-plate -black -text-white">
                <div className="email_content-plate-grid">
                  <div className="email_content-plate-p -bold -md">
                    Find a store
                  </div>
                  <div className="email_icon-arrow-out" />
                </div>
              </div>
            </div>
            <div className="email_content-col">
              <div className="email_content-plate -black -text-white">
                <div className="email_content-plate-grid">
                  <div className="email_content-plate-p -bold -md">Call { telNumber }</div>
                  <div className="email_icon-arrow-out" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="email_footer">
        <ul className="email_footer-menu -main">
          <li>Phones</li>
          <li>Tablets</li>
          <li>Accessories</li>
          <li>Plans</li>
          <li>Contact us</li>
        </ul>
        <FooterSocialMenu />
        <div className="email_footer-texts">
          <p>
            <b>*Wi-Fi Backup:</b> Wi-Fi Backup at $20/mo. when combined with postpaid Verizon mobile phone plan (excludes business and data-only plans). Auto Pay & paper-free billing req’d. Availability varies. Subject to credit approval.
          </p>
          <p>
            For backup use in the event of primary internet provider network outage. Backup power source required for use during power outage. Verizon owns the equipment provided with your plan, including the router. If you choose to disconnect service, you must return equipment within 30 days or you’ll incur an unreturned equipment fee(s). Download speeds up to 50 Mbps; Upload speeds up to 6 Mbps. On 5G Ultra Wideband, typical download speeds of 25-50 Mbps and upload speeds of 3-6 Mbps. On 5G/4G LTE, typical download speeds of 3-25 Mbps and upload speeds of 1-3 Mbps. Some customers may only get 5G/4G LTE. Data usage is subject to Verizon's Customer Agreement.
          </p>
          <p>
            © 2025 Verizon
          </p>
          <p>
            This email was sent to username@domain.com. We respect your privacy. Please review our <span className="underline">Privacy Policy</span>. California
            customers can view our <span className="underline">California Privacy Notice</span>. You may <span className="underline">unsubscribe</span> from Verizon promotional emails at any time.
          </p>
          <p>
            Verizon, One Verizon Way, Mail Code: 180WVB, Basking Ridge, NJ 07920
          </p>
        </div>
      </div>
    </div>
  );
};

export default WifiBackup;
